import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getErrorMessage } from '../utils';
import { resetPassword } from '../store/actions/auth';

const useStyles = makeStyles(() => ({
  resetWrapper: {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'dimgray',
  },
  cardWrapper: {
    width: '50%',
    boxSizing: 'border-box',
    padding: '5em',
    margin: 'auto',
    position: 'absolute',
    top: '15%',
    left: '25%',
  },
  registerButton: {
    marginTop: 16,
  },
  error: {
    color: 'red',
  },
}));

const ResetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const serverErrors = useSelector((state) => state.auth.error);
  const { token } = useParams();
  const [displayError, setDisplayError] = useState([]);

  useEffect(() => {
    if (serverErrors) {
      setDisplayError(getErrorMessage(serverErrors));
    }
  }, [serverErrors]);

  const submitHandler = (values) => {
    const payload = {
      username: values.email.toLowerCase(),
      password: values.password,
      token,
    };
    dispatch(resetPassword(payload, history));
  };

  const validationSchema = yup.object({
    email: yup.string().email('Enter a valid email').required('*Required'),
    password: yup.string().required('*Required'),
    'password-validate': yup
      .string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required('*Required'),
  });

  return (
    <div className={classes.resetWrapper}>
      <CssBaseline />
      <Card className={classes.cardWrapper}>
        <CardHeader title="Reset Password" />
        <CardContent>
          <Formik
            initialValues={{ email: '', password: '', 'password-validate': '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                submitHandler(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => {
              return (
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div className={classes.nameFieldContainer}>
                    <TextField
                      classes={{ root: 'text-field' }}
                      fullWidth
                      placeholder="Email*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      name="email"
                      label="Email*"
                    />
                    <p className={classes.error}>{errors.email && touched.email && errors.email}</p>
                  </div>
                  <div className={classes.nameFieldContainer}>
                    <TextField
                      classes={{ root: 'text-field' }}
                      fullWidth
                      placeholder="Password*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      name="password"
                      type="password"
                      label="Password*"
                    />
                    <p className={classes.error}>{errors.password && touched.password && errors.password}</p>
                  </div>
                  <div className={classes.nameFieldContainer}>
                    <TextField
                      classes={{ root: 'text-field' }}
                      fullWidth
                      placeholder="Re-Enter Password*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values['password-validate']}
                      name="password-validate"
                      type="password"
                      label="Re-Enter Password*"
                    />
                    <p className={classes.error}>
                      {errors['password-validate'] && touched['password-validate'] && errors['password-validate']}
                    </p>
                  </div>
                  {displayError &&
                    displayError.map((error) => (
                      <div key={error} style={{ color: 'red' }}>
                        {error}
                      </div>
                    ))}
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                    className={classes.registerButton}
                  >
                    Set Password
                  </Button>
                </form>
              );
            }}
          </Formik>
        </CardContent>
      </Card>
    </div>
  );
};

export default ResetPassword;
